/* eslint-disable */
import { useSearchParams } from "react-router-dom";
import OpCodeSearchForm from "src/components/OpCodeSearchForm2";
import { Card, CardContent } from "src/components/ui/card";

export default function TemplatePage() {

    const [searchParams] = useSearchParams();
    // const frameTemplateName = "665467d84b7c867c744381a0/app_0v8BQ1YEroTOt1VaMswtzKvk/OpCode-Create-Trainer_Template"
    const orgId = searchParams.get("orgId")
    const appId = searchParams.get("appId")
    const templateName = searchParams.get("templateName")
    const frameTemplateName = `${orgId}/${appId}/${templateName}`;
    console.log("Frame template name ", frameTemplateName)

    const apiCalls = [
        {
            key: "templateJson",
            onLoad: true,
            onButton: false,
            server: 2,
        },
        {
            key: "bexInsights",
            onLoad: true,
            onButton: true,
            param: ["64f9f31ab8f2b3a65cbfc48d", "app_KxP3dT89OKINC3n4hPORey6v"],
            server: 1,
        },
    ]

    return (
        <Card>
            <CardContent>
                <OpCodeSearchForm
                    setFields=""
                    setUserId=""
                    templateName={
                        frameTemplateName
                    }
                    prevFrame={null}
                    needCreate={false}
                    isUserStory={true}
                    filter={null}
                    apiCalls={apiCalls}
                />
            </CardContent>
        </Card>
    )
}